import type {
  PagamentoSolicitacaoListItem,
  PagamentoSolicitacoesListResponse,
} from "../../../services/pagamentoAvaliacaoService";
import type { PaymentListItem } from "./paymentListTypes";
import {
  parseSolicitacaoNumero,
  resolveSituacaoPagamento,
} from "./paymentListUtils";

export function extractAnosModeloPagamento(
  response: PagamentoSolicitacoesListResponse | null | undefined,
): number[] {
  const anos = (Array.isArray(response?.avaliacoesModelo)
    ? response.avaliacoesModelo
    : []
  )
    .map((m) => Number(m?.anoReferencia))
    .filter((n) => Number.isFinite(n) && n > 0);
  return [...new Set(anos)].sort((a, b) => b - a);
}

export function mapPagamentoSolicitacoesToList(
  items: PagamentoSolicitacaoListItem[] | null | undefined,
  ano: number,
): PaymentListItem[] {
  if (!Array.isArray(items)) return [];

  return items.map((item, index) => {
    const comprovanteId = Number(item?.comprovanteId) || 0;
    const sindicatoId = Number(item?.sindicatoId) || 0;
    const idPagamento =
      Number(
        item?.pagamentoId ||
          item?.idPagamento ||
          item?.pagamentoDespesasAvaliacaoId,
      ) || 0;
    const id = comprovanteId || idPagamento || sindicatoId || index + 1;

    return {
      id,
      idSolicitacao: comprovanteId || id,
      idPagamento: idPagamento || undefined,
      ano,
      cnpj: item?.cnpj || "",
      sigla: item?.sigla || "",
      nomeSindicato: item?.nome || "",
      situacaoPagamento: resolveSituacaoPagamento(item?.situacao),
      solicitacao: parseSolicitacaoNumero(item?.solicitacao),
      dataAssinaturaSolicitacao: item?.assinadoEm || null,
      dataEmissao: item?.emitidoEm || null,
      valorBruto: item?.valorBruto == null ? null : Number(item.valorBruto),
    };
  });
}
